import { GridToolbar } from '@mui/x-data-grid-premium';

// Shared styling configuration for all DataGrid tables
export const DATAGRID_STYLES = {
  '& .MuiDataGridColumnHeaderTitle': {
    fontWeight: '600',
  },
  '& .MuiDataGridCell': {
    borderBottom: '1px solid #e0e0e0',
    paddingTop: '8px',
    paddingBottom: '8px',
    alignItems: 'center',
    display: 'flex',
  },
  '& .MuiDataGridColumnHeaders': {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #e0e0e0',
  },
};

// Default props for all DataGrid tables
export const DATAGRID_DEFAULT_PROPS = {
  density: 'compact' as const,
  showCellVerticalBorder: true,
  // Enable export functionality
  slots: {
    toolbar: GridToolbar,
  },
  localeText: {
    noRowsLabel: 'No rows found',
  },
};
